import React from "react";
import {
  Button,
  Divider,
  Input,
  Modal,
  Select,
  Tag,
  Table,
} from "antd";
import CloseIcon from '@mui/icons-material/Close';
import AuthService from "../auth/AuthService";
import config from "../config";
import { DATE_FORMAT, HelperReminderTasks } from "../common/constants";
import { Box, Button as UploadButton } from "@mui/material";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useLoadingDispatch } from "../../context/loadingContext";
import moment from "moment";
import { Modal as MUIModal, Typography, IconButton, Button as MUIButton} from "@mui/material";
import dayjs from "dayjs";

const Auth = new AuthService();

const HelperTaskHistoryModal = ({ isModalOpen, setIsModalOpen, history, setHistory }) => {
  const { Option } = Select;
  const { TextArea } = Input;
  var layoutDispatch = useLoadingDispatch();
  const [filesOpen, setFilesOpen] = React.useState(false);
  const [selectedRecordId, setSelectedRecordId] = React.useState(0);
  const [selectedFiles, setSelectedFiles] = React.useState([]);

  const [screenWidth, setScreenWidth] = React.useState("");
  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleFilesOpen = (row) => {
    if (row?.files) {
      setSelectedRecordId(row.id);
      setSelectedFiles(JSON.parse(row?.files));
    }
    setFilesOpen(true);
  };

  const handleFilesClose = () => setFilesOpen(false);

  const historyCol = [
    
    {
      title: 'Due Date',
      render: (record )=> {
        return (
          <>
          <span>{dayjs(record.due_date).format(DATE_FORMAT)}</span>
        </>
        )
       
      }
    },
    {
      align: "center",
      title: "Status",
      render: ({ due_date }) => {
        return (
          <Tag color={'#339900'} icon={<CheckCircleOutlined />} style={{ marginLeft: '4px' }}>
            Completed
          </Tag>
        );
      },
    },
    {
      align: "center",
      title: "Service Task",
      render: (record) => {
          const info = HelperReminderTasks.find((obj) => obj.id === record?.type);
        return (
          <>
          <span>{info?.title || ""}</span><br/>
          <span style={{ fontSize: '10px', color: 'darkgrey'}}>{info?.message}</span>
          </>
        );
      },
    },
    {
      align: "center",
      title: "Completed at",
      render: (record) => {
        return (
          <>
          <span>{record.completion_date ? dayjs(record.completion_date).format(DATE_FORMAT) : null}</span>
          </>
          
        );
      },
    },
    {
        title: "Notes",
        dataIndex: "notes",
        key: "notes",
    },
    {
        title: 'Files',
        render: (record) => {
          return record?.files != null &&  record?.files != ""  && JSON.parse(record?.files)?.length > 0 ? (
            <MUIButton
              onClick={() => {
                handleFilesOpen(record);
              }}
            >
              {JSON.parse(record?.files)?.length + "-Files"}
            </MUIButton>
          ) : (
            <MUIButton
            disabled
            >
              { "0-Files"}
            </MUIButton>
          )
        },
      },
  ];
  

  const handleCancel = () => {
    setIsModalOpen(false);
    resetState();
  };

  const resetState = () => {
    setHistory([])
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        // onOk={handleOk}
        onCancel={handleCancel}
        title={"Helper Reminder History "}
        footer={[
          <>
            <Button onClick={handleCancel}>{"Close"}</Button>
            
          </>,
        ]}
      >
        <>
          <Divider />
          <Table dataSource={history} columns={historyCol} style={{ marginTop: "4px"}} pagination={false} />

        </>
        {/* ==================popup for Showing uploaded Image==================== */}
      <MUIModal
          open={filesOpen}
          onClose={handleFilesClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              overflowY: "auto",
              maxHeight: "90vh",
              transform: "translate(-50%, -50%)",
              width: screenWidth < 610 ? "90%" : 600,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <IconButton
            edge="end"
            color="inherit"
            onClick={handleFilesClose}
            aria-label="close"
            sx={{ position: 'absolute', top: 0, right: 0, marginRight: '5px'}}
        >
          <CloseIcon />
        </IconButton>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Download the files below
            </Typography>
            {selectedFiles.length > 0 && (
              <p style={{ padding: "0" }}>Files</p>
            )}
            {selectedFiles.length > 0 &&
              selectedFiles.map((file, idx) => {
              const lastHyphenIndex = file.lastIndexOf('-')
              const dotBeforeExtensionIndex = file.lastIndexOf('.');
              const newFileName = file.slice(0, lastHyphenIndex) + file.slice(dotBeforeExtensionIndex);
                return (
                  <li key={idx}>
                    <a
                      href={`${config.tms_uploads_cdn}/${config.env}/reminders-helper/${selectedRecordId}/${file}`}
                      target="_blank"
                    >
                      {newFileName}
                    </a>
                  </li>
                );
              })}
          </Box>
        </MUIModal>
      </Modal>
    </>
  );
};

export default HelperTaskHistoryModal;
